import clsx from "clsx";
import TestimonialCard from "components/organism/Cards/TestimonialCard";
import { testimonialList } from "data";
import { TextBadge, SectionTitle, Subtitle } from "components/atoms/Text";

const Testimonial = () => {
    return (
        <section className="features w-full max-w-[1440px] mx-auto tablet:py-16 py-[96px] phone:py-12">
            <section className={clsx(
                "w-full mx-auto max-w-full tablet:max-w-[690px] desktop:max-w-[603px] bg-neutral-10 text-center",
                "px-6 md:px-0"
            )}>
                <TextBadge>Testimonial</TextBadge>
                <SectionTitle classNames="phone:max-w-[300px] mx-auto">What Our Customer Say</SectionTitle>
                <Subtitle classNames="tablet:max-w-[524px] desktop:max-w-[509px] phone:!text-[16px] desktop:mx-auto tablet:mx-auto">With almost a decade in the business and tens of thousands of happy customers, you are in the best of hands.</Subtitle>
            </section>
            <section className={clsx(
                "grid grid-cols-1 md:grid-cols-3 phone:gap-6 tablet:gap-6 gap-8",
                "py-[80px] tablet:pt-14 tablet:pb-0 desktop:pb-0 desktop:pt-[72px] phone:pt-12 phone:pb-0 px-6 tablet:px-8 desktop:px-[120px]"
            )}>
                {testimonialList.map((item) => (
                    <TestimonialCard key={item.id} author={item.author} img={item.img} position={item.position} message={item.message} />
                ))}
            </section>
        </section>
    );
};

export default Testimonial;